module.exports = __webpack_public_path__ + "img/image (113).c27678cf.jpg";